import { Button } from '@eb/eds-button';
import { EventClient, EventClientProvider } from '@eb/event-renderer';
import { gettext } from '@eb/i18n';
import React, { useRef, useState } from 'react';
import { DiscoveryEventsFromView } from '../types';
import { EventRenderer } from './EventRenderer';

interface OrganizerEventsInternalProps {
    events: DiscoveryEventsFromView;
}

enum EventStates {
    'future',
    'past',
}

const eventClient = new EventClient();

export const OrganizerEvents: React.FunctionComponent<OrganizerEventsInternalProps> = (
    props,
) => {
    const { future_events, past_events, ...eventMetaData } = props.events;
    const [eventType, setEventType] = useState(EventStates.future);
    const hasRenderedPastEvents = useRef(false);

    if (eventType === EventStates.past && !hasRenderedPastEvents.current) {
        hasRenderedPastEvents.current = true;
    }

    return (
        <EventClientProvider client={eventClient}>
            <h2 className="organizer-events__header eds-text-hm">
                {gettext('Events')}
            </h2>
            <section className="organizer-events__event-controls">
                <Button
                    onClick={() => setEventType(EventStates.future)}
                    style={
                        eventType === EventStates.future ? 'follow' : 'neutral'
                    }
                    isFollowing={eventType === EventStates.future}
                >
                    {gettext('Upcoming (%(numFutureEvents)s)', {
                        numFutureEvents: eventMetaData.num_future_events,
                    })}
                </Button>
                <Button
                    onClick={() => setEventType(EventStates.past)}
                    style={
                        eventType === EventStates.past ? 'follow' : 'neutral'
                    }
                    isFollowing={eventType === EventStates.past}
                >
                    {gettext('Past (%(numPastEvents)s)', {
                        numPastEvents: eventMetaData.num_past_events,
                    })}
                </Button>
            </section>
            <div className={eventType === EventStates.future ? '' : 'eds-hide'}>
                <EventRenderer
                    eventMetaData={eventMetaData}
                    events={future_events}
                    removeSaveHandlers={false}
                    type="future"
                />
            </div>
            {hasRenderedPastEvents ? (
                <div
                    className={eventType === EventStates.past ? '' : 'eds-hide'}
                >
                    <EventRenderer
                        eventMetaData={eventMetaData}
                        events={past_events}
                        removeSaveHandlers={true}
                        type="past"
                    />
                </div>
            ) : null}
        </EventClientProvider>
    );
};
